import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';

import { Avatar } from '@material-ui/core'
import { colors, Grid } from '@material-ui/core';

const rows = [{
    name: 'Caroline kingsley',
    email: 'caroline@example.com',
    image: '/images/avatars/image1.jpg',
    status: 'active',
    location: 'England',
    code: 'EN001'
},
{
    name: 'Jennifer wu',
    email: 'jennifer@example.com',
    image: '/images/avatars/image2.jpg',
    status: 'inactive',
    location: 'Kenya',
    code: 'KN001'
},
{
    name: 'Jonathan bradley',
    email: 'jonathan@example.com',
    image: '/images/avatars/image3.jpg',
    status: 'active',
    location: 'Germany',
    code: 'GE001'
},
{
    name: 'Michael jones',
    email: 'michae@example.com',
    image: '/images/avatars/image4.jpg',
    status: 'active',
    location: 'Denmark',
    code: 'DN001'
},
{
    name: 'Olivia green',
    email: 'olivia@example.com',
    image: '/images/avatars/image5.jpg',
    status: 'active',
    location: 'Cameroon',
    code: 'CA001'
},
{
    name: 'Lambert',
    email: 'lambert@example.com',
    image: '/images/avatars/image6.jpg',
    status: 'inactive',
    location: 'Brazil',
    code: 'BZ001'
},
{
    name: 'John Doe',
    email: 'caroline@example.com',
    image: '/images/avatars/image7.jpg',
    status: 'active',
    location: 'England',
    code: 'EN001'
},
{
    name: 'Alexa Richardson',
    email: 'Alexa@example.com',
    image: '/images/avatars/image8.jpg',
    status: 'active',
    location: 'Korea',
    code: 'KN001'
},
{
    name: 'Cristian',
    email: 'Cristian@example.com',
    image: '/images/avatars/image9.jpg',
    status: 'active',
    location: 'Canada',
    code: 'CN001'
},
{
    name: 'Cristia',
    email: 'Cristia@example.com',
    image: '/images/avatars/image91.jpg',
    status: 'active',
    location: 'Landon',
    code: 'LN001'
}

]

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'name' },
  { id: 'email', numeric: false, disablePadding: false, label: 'email' },
  { id: 'status', numeric: false, disablePadding: false, label: 'status' },
  { id: 'location', numeric: false, disablePadding: false, label: 'location' },
  { id: 'code', numeric: false, disablePadding: false, label: 'code' },
];

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all clients' }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          Clients List
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton aria-label="filter list">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    //minWidth: 750
    marginTop: 15
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  avatar: {
    width:50,
    height:50
  },
  scroll:{
      minWidth: 500,
      // marginTop: 15
  },
  status: {
    height: 15,
    width: 15,
    backgroundColor: '#bbb',
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: 4
  },
  statusDiv:{
      display: 'flex',
      alignItems: 'center'
  },
  rootMain: {
    display:'flex',
    flexDirection: 'column',
    flex:1
   },
   gridContainerOuter:{
       margin: '6px -6px',
       display: 'flex',
       justifyContent: 'center'
   },
   gridItemInner:{
      padding : '3px 6px',
      width: '100%'
   },

   titleDiv: {
    padding: '8px 0px 12px 0px'
},
}));

export default function Clients() {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('name');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  //const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

//   const handleChangeDense = (event) => {
//     setDense(event.target.checked);
//   };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div className={classes.rootMain}>


        <div className={classes.titleDiv}>
             <Typography variant="h2">Clients List</Typography>
        </div>
        {/* <div> */}
            <Grid container  className={classes.gridContainerOuter}>
                <Grid item xs={12}  className={classes.gridItemInner}>

               
      <div className={classes.scroll}>
        

    
   
      <Paper className={classes.paper}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer>
       
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            //size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.name)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row" padding="none">
                        <Avatar 
                        alt= {`logo-${row.name}`} 
                        src= {row.image}
                        className={classes.avatar}
                        />
                        <Typography variant="h6" className={classes.name}>
                        {row.name}
                        </Typography>
                        {/* {row.name} */}
                      </TableCell>
                      <TableCell >{row.email}</TableCell>
                      <TableCell >
                          <div className={classes.statusDiv}>
                          <span className={classes.status}
                          style={{
                              backgroundColor: row.status=='active' ? colors.green[400]   :  colors.red[400]
                            }}
                          ></span> {row.status}
                          </div>
                          </TableCell>
                      <TableCell >{row.location}</TableCell>
                      <TableCell >{row.code}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                // <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                <TableRow>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
       
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}

        
    </div>
    </Grid>
    </Grid>
    </div>
  );
}